import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Site from "./components/Site/Site";
import Enquiry from "./components/Enquiry/Enquiry";
import { loadSingleSite } from "../SiteList/SiteList.actionCreators";

import {
  DocumentListViewContainer,
  SectionContainer,
  HeaderButton,
  HeaderRow,
  Circle,
} from "./AddEditSite.styled";

const AddEditSite = (props) => {
  const { t, id, isEditMode, siteData } = props;
  const dispatch = useDispatch();
  const params = useParams();
  const queryParams = new URLSearchParams(window.location.search);
  const leadId = queryParams.get("leadId");
  const [activeTab, setActiveTab] = useState("site");

  const siteId = parseInt(params.id, 10);
  const companyId = params?.companyId ? parseInt(params?.companyId, 10) : null;
  const siteInfo = useSelector((state) => state.siteList.byId[id]);
  const [selectedSite, setSelectedSite] = useState({});
  const [isLeadJobsite, setLeadJobsite] = useState(false);
  const selectedSiteData = useSelector((state) => state.siteList.selectedSite);

  const fetchSiteInfo = () => {
    if (!Number.isInteger(siteId) || siteId <= 0) {
      return;
    }
    dispatch(
      loadSingleSite({
        siteId,
      })
    );
  };

  const fetchLeadInfo = () => {
    axios
      .get(`/leads/${leadId}`)
      .then((response) => {
        setSelectedSite(response?.data[0]);
        setLeadJobsite(true);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (siteInfo === undefined && (isEditMode || siteId)) {
      fetchSiteInfo();
    }
    if (leadId) {
      fetchLeadInfo();
    }
  }, [siteInfo, siteId]);

  useEffect(() => {
    if (!leadId) {
      if (
        siteInfo !== undefined &&
        parseInt(siteId, 10) === parseInt(siteInfo.id, 10)
      ) {
        setSelectedSite(siteInfo);
      }
      if (
        selectedSiteData !== null &&
        parseInt(siteId, 10) === parseInt(selectedSiteData.id, 10)
      ) {
        setSelectedSite(selectedSiteData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteInfo, selectedSiteData]);

  if (Object.keys(selectedSite).length === 0 && companyId) {
    setSelectedSite({ company: { id: companyId } });
  }

  const toggleTab = (tab) => {
    if (selectedSite?.id && isEditMode) setActiveTab("site");
    if (selectedSite?.id && !isEditMode) setActiveTab(tab);
  };

  return (
    <DocumentListViewContainer>
      <SectionContainer>
        <HeaderRow>
          <HeaderButton
            marginRight="10px"
            color={
              activeTab === "site"
                ? siteData?.id
                  ? "#008395"
                  : "#00AEEA"
                : "#cccccc"
            }
            zIndex="99"
            width="102%"
            onClick={() => toggleTab("site")}
          >
            <Circle color={activeTab === "site" ? "#00AEEA" : "#cccccc"}>
              1
            </Circle>
            <span>{t("GENERAL_INFORMATION")}</span>
          </HeaderButton>

          {!isEditMode && (
            <HeaderButton
              marginRight="10px"
              color={activeTab === "enquiry" ? "#00AEEA" : "#cccccc"}
              width="110%"
              onClick={() => toggleTab("enquiry")}
            >
              <Circle color={activeTab === "enquiry" ? "#00AEEA" : "#cccccc"}>
                2
              </Circle>
              <span>{t("ENQUIRY_INFORMATION")}</span>
            </HeaderButton>
          )}
        </HeaderRow>
        {activeTab === "site" && (
          <Site
            id={selectedSite?.id ?? null}
            selectedSite={selectedSite}
            setSelectedSite={setSelectedSite}
            isEditMode={isEditMode}
            setActiveTab={setActiveTab}
            isLeadJobsite={isLeadJobsite}
            setLeadJobsite={setLeadJobsite}
            leadId={leadId ? parseInt(leadId, 10) : leadId}
          />
        )}
        {activeTab === "enquiry" && (
          <Enquiry setActiveTab={setActiveTab} siteData={selectedSite} />
        )}
      </SectionContainer>
    </DocumentListViewContainer>
  );
};
AddEditSite.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  isEditMode: PropTypes.bool,
  siteData: PropTypes.object,
};
AddEditSite.defaultProps = {
  id: null,
  isEditMode: false,
  siteData: null,
};

export default withTranslation()(AddEditSite);
